import { rootMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import SvgAt from '@img/icons/@.svg';
import SvgContact from '@img/icons/chat.svg';
import SvgPhone from '@img/icons/phone-solid.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './ProfileIntroduction.styles';
import { linkAria } from '@helpers/utils';
const ProfileIntroduction = (props) => {
    const [ref, inView] = useInView({ rootMargin }, false);
    return (React.createElement(S.Container, { id: props.anchorId, ref: ref, "data-animate": inView, style: {
            '--progress': props.progress ? props.progress * 0.33 : 0,
        } },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentArea, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Message, { dangerouslySetInnerHTML: { __html: props.message } })),
            React.createElement(S.BoxArea, null, props.supportCard && (React.createElement(S.SupportCard, null,
                React.createElement(S.SupportCardTitle, null,
                    React.createElement(SvgContact, null),
                    " ",
                    props.supportCard.title),
                props.supportCard.content && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.supportCard.content } })),
                props.supportCard.telCta || props.supportCard.emailCta ? (React.createElement(S.TelEmailList, null,
                    props.supportCard.telCta && (React.createElement("li", null,
                        React.createElement("span", null,
                            React.createElement(SvgPhone, null)),
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement("a", { "aria-label": linkAria(props.supportCard.telCta.text ?? '', props.supportCard.telCta.target, props.translations && props.translations['lcci.link.newtab']), href: `tel:${props.supportCard.telCta.url}`, target: props.supportCard.telCta.target }, props.supportCard.telCta.text)))),
                    props.supportCard.emailCta && (React.createElement("li", null,
                        React.createElement("span", null,
                            React.createElement(SvgAt, null)),
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement("a", { "aria-label": linkAria(props.supportCard.emailCta.text ?? '', props.supportCard.emailCta.target, props.translations && props.translations['lcci.link.newtab']), href: `malto:${props.supportCard.emailCta.url}`, target: props.supportCard.emailCta.target }, props.supportCard.emailCta.text)))))) : null))))));
};
export default ProfileIntroduction;
